import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CartItem } from 'retail/app/common/models/cart-item';
import { CartService } from 'retail/app/common/providers/cart.service';
import { CreateOrderModel } from 'retail/app/orders/models/create-order.model';
import { CheckoutService } from 'retail/app/orders/providers/checkout.service';
import { OrdersService } from 'retail/app/orders/providers/orders.service';
import { RetailAnalyticsService } from 'retail/app/retail-analytics.service';
import { VAT } from 'shared-ui/models/vat';
import { FlashMessages } from 'shared-ui/providers/flash-messages';
import { ProgressService } from 'shared-ui/providers/progress.service';
import { AppValidators } from 'shared-ui/validators/app-validators';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit {
  readonly defaultImage = '/assets/placeholder.jpg';
  readonly vat = VAT;
  stepperIndex = 1;
  shipmentControl = new FormControl(false, [AppValidators.true()]);
  infoControl = new FormControl(false, [AppValidators.true]);
  cartItems: CartItem[] = [];
  complete = false;
  order?: CreateOrderModel;

  constructor(
    private checkoutService: CheckoutService,
    private cartService: CartService,
    private ordersService: OrdersService,
    private progress: ProgressService,
    private flashMessages: FlashMessages,
    private router: Router,
    private meta: Meta,
    private title: Title,
    private analyticsService: RetailAnalyticsService
  ) {
    this.setMetadata();
  }

  ngOnInit(): void {
    this.cartItems = this.cartService.cartItems;
    this.cartService.cartUpdate.subscribe(value => (this.cartItems = value));
  }

  stepperChange(event: StepperSelectionEvent) {
    this.stepperIndex = event.selectedIndex;
    if (event.selectedIndex === 0) {
      this.router.navigate(['/o/kosik']);
    }
  }

  goBack() {
    if (this.stepperIndex > 0) {
      this.stepperIndex--;
    }
  }

  goToCustomerInfo() {
    this.shipmentControl.setValue(true);
    this.stepperIndex++;
  }

  goToConfirmation() {
    this.infoControl.setValue(true);
    this.stepperIndex++;
    this.order = this.ordersService.loadFullOrder();
  }

  confirmOrder() {
    const order = this.order;
    if (!order) return;
    this.progress.pageLoadStart();
    this.ordersService.sendOrder(order).subscribe({
      next: () => {
        this.analyticsService.logPurchase(order);
        this.cartService.clearCart();
        this.ordersService.clearOrder();
        this.complete = true;
        this.cartItems = [];
        this.progress.pageLoadEnd();
      },
      error: () => {
        this.progress.pageLoadEnd();
        this.flashMessages.show('There was an error processing your order. Please try again.');
      },
    });
  }

  private setMetadata() {
    this.title.setTitle(`Objednávka | BEROP.cz`);
    this.meta.updateTag({
      name: 'keywords',
      content: 'Objednávka',
    });
    this.meta.updateTag({
      name: 'description',
      content: 'Objednávka',
    });
  }
}
